import { type TranslationMessages } from 'react-admin'
import jaMessages from '@bicstone/ra-language-japanese'

export const ja: TranslationMessages = {
  ...jaMessages,
  resources: {
    orderR: {
      title: '<%= name %>サービス',
      header:
        '私(電気契約者)は、テラシテRサービス利用規約、注意事項および電力使用状況の異変検知時に緊急連絡先や不動産管理会社(賃貸人を含む)、<%= partner %>へ個人情報を提供することについて、入居者、緊急連絡先にテラシテRの内容を説明し、入居者、緊急連絡先から同意を得ていることを誓約のうえ申込みをします。',
      manual: '手続き方法はこちら',
      subtitles: {
        title_0: '入居者情報の入力',
        title_1: '電気契約者情報の入力',
        title_2: '緊急連絡先情報の入力',
        title_3: 'お支払い方法の選択',
        title_4: '入力内容の確認',
        title_5: '入力内容の確認'
      },
      fields: {
        lessee: {
          name: '賃借人氏名'
        },
        user: {
          name: '氏名',
          lastName: '姓',
          firstName: '名',
          nameKana: '氏名(カナ)',
          lastNameKana: 'セイ(全角文字)',
          firstNameKana: 'メイ(全角文字）',
          postalCode: '物件郵便番号(ハイフンなし)',
          address: '物件住所',
          place: '物件名',
          placeNumber: '部屋番号',
          phone: '携帯電話番号(ハイフンなし)',
          email: 'メールアドレス',
          country: '通知および音声通話で使用する言語',
          entry: '入居日(入居予定日)'
        },
        families: {
          name: '氏名',
          lastName: '姓',
          firstName: '名',
          nameKana: '氏名(カナ)',
          lastNameKana: 'セイ(全角文字)',
          firstNameKana: 'メイ(全角文字)',
          phone: '電話番号(ハイフンなし)',
          email: 'メールアドレス',
          postalCode: '郵便番号(ハイフンなし)',
          country: '通知および音声通話で使用する言語',
          isAnotherPerson:
            '緊急連絡先として登録する方は、ご入居者様本人とは別の方であり、\n事前に緊急連絡先として登録することに同意を得ていることを確認しました。'
        },
        contractor: {
          name: '氏名',
          lastName: '姓',
          firstName: '名',
          nameKana: '氏名(カナ)',
          lastNameKana: 'セイ(全角文字)',
          firstNameKana: 'メイ(全角文字)',
          postalCode: '郵便番号(ハイフンなし)',
          address: '現住所',
          phone: '電話番号(ハイフンなし)',
          email: 'メールアドレス'
        },
        payments: {
          creditCard: 'クレジットカード',
          directDebit: '口座振替',
          monthly: '月払い',
          yearly: '年払い'
        },
        bankAccount: {
          title: '口座情報のご登録',
          bankCode: '銀行コード',
          branchCode: '支店コード',
          accountType: '口座区分',
          accountNumber: '口座番号',
          accountName: '口座名義（カナ）',
          accountNameKanji: '口座名義（漢字）',
          dialog: {
            content: '金融機関サイトへ移動します',
            ok: '確認'
          }
        },
        savings: '普通',
        current: '当座',
        paymentMethod: 'お支払い方法',
        paymentTerm: 'お支払い期間',
        necessaryEKYC: '電気契約者と賃借人が異なる',
        necessaryContractor: '入居者と電気契約者が異なる',
        noFamilies: '緊急連絡先を使用しない',
        agreement: '上記のサービス利用規約に同意します。',
        agreementDisabled: '上記のサービス利用規約に同意します。',
        entryDateDescription:
          '※1ヶ月以上前にご入居された方は、「入居済み」にチェックを入力ください。\n新規入居もしくは1ヶ月以内に入居された方は入居日（入居予定日）を入力ください。',
        noEntryDate: '入居済み',
        contactDuplexCheck: 'ご本人さまと異なるご連絡先を入力してください。'
      },
      showFields: {
        lessee: {
          name: '賃借人氏名'
        },
        user: {
          name: '入居者氏名',
          lastName: '入居者氏名 (姓)',
          firstName: '入居者氏名 (名)',
          nameKana: '入居者氏名(カナ)',
          lastNameKana: '入居者氏名カナ (姓)',
          firstNameKana: '入居者氏名カナ (名)',
          postalCode: '物件郵便番号',
          address: '物件住所',
          place: '物件名',
          placeNumber: '部屋番号',
          phone: '入居者携帯電話番号',
          email: '入居者メールアドレス',
          country: '通知および音声通話で使用する言語',
          entry: '入居日(入居予定日)'
        },
        families: {
          name: '緊急連絡先氏名',
          lastName: '緊急連絡先氏名 (姓)',
          firstName: '緊急連絡先氏名 (名)',
          nameKana: '緊急連絡先氏名(カナ)',
          lastNameKana: '緊急連絡先氏名カナ (姓)',
          firstNameKana: '緊急連絡先氏名カナ (名)',
          phone: '緊急連絡先電話番号',
          email: '緊急連絡先メールアドレス',
          postalCode: '緊急連絡先郵便番号',
          country: '通知および音声通話で使用する言語'
        },
        contractor: {
          name: '電気契約者氏名',
          lastName: '電気契約者氏名 (姓)',
          firstName: '電気契約者氏名 (名)',
          nameKana: '電気契約者氏名(カナ)',
          lastNameKana: '電気契約者氏名カナ (姓)',
          firstNameKana: '電気契約者氏名カナ (名)',
          postalCode: '電気契約者郵便番号',
          address: '電気契約者住所',
          phone: '電気契約者電話番号',
          email: '電気契約者メールアドレス'
        },
        paymentMethod: 'お支払い方法',
        paymentTerm: 'お支払い期間',
        payments: {
          descriptions: {
            noCommission: '※手数料はかかりません',
            commission: '※手数料として、決済1回あたり200円(税抜)がかかります。'
          }
        }
      },
      buttons: {
        addressInput: '住所自動入力',
        submit: '登録',
        confirm: '確認',
        next: '次へ',
        back: '戻る',
        ekyc: 'ご本人確認を実行',
        sign: '電力データ提供の同意手続きを実行'
      },
      confirms: {
        submit: {
          content: 'ご入力された内容でお申し込みを行います。',
          confirm: '実行'
        }
      },
      yesNo: {
        yes: 'はい',
        no: 'いいえ'
      },
      complete: {
        thanks:
          'お申し込みありがとうございます。\n※まだお手続きは完了してません。',
        thanksComplete: 'お申し込みありがとうございます。',
        sendToContractorForBoth:
          '電気契約者さまに①本人確認<% if(registPaymentMethod) {%>と決済情報の登録のご案内<% }%>、②電力データ提供の同意お手続きに関するご案内をメールでお送りしております。\n内容をご確認のうえ、お手続きをお願いします。',
        sendToContractorForSign:
          '電気契約者さまに<% if(registPaymentMethod) {%>①決済情報の登録のご案内、②<% }%>電力データ提供の同意お手続きに関するご案内をメールでお送りしております。\n内容をご確認のうえ、お手続きをお願いします。',
        sendForBoth:
          '入居者さまに①本人確認<% if(registPaymentMethod) {%>と決済情報の登録のご案内<% }%>、②電力データ提供の同意お手続きに関するご案内をメールでお送りしております。\n内容をご確認のうえ、お手続きをお願いします。',
        sendForSign:
          '入居者さまに<% if(registPaymentMethod) {%>①決済情報の登録のご案内、②<% }%>電力データ提供の同意お手続きに関するご案内をメールでお送りしております。\n内容をご確認のうえ、お手続きをお願いします。',
        doBoth:
          '本人確認および電力データ提供の同意お手続きを実施いただきます。',
        doSign:
          '電力データご提供の同意お手続きに関するご案内をメールでお送りしております。\n内容をご確認のうえ、お手続きをお願いします。',
        ekyc: 'ご本人確認はスマートフォンで実施をお願いいたします。'
      },
      attention: {
        ekyc: {
          title: '本人認証のお願い',
          body: 'オンラインの本人認証サービス（eKYCサービス）による本人認証が必要となります。\n対応可能な本人確認書類は運転免許証、マイナンバーカード、在留カード、パスポート、特別永住者証明書、運転経歴証明書となります。'
        }
      }
    },
    ekyc: {
      title: '<%= name %>のお申し込みにおけるご本人確認',
      thanks:
        'お申込みいただきました <%= place %>・<%= placeNumber %> の入居者見守りサービス(<%= service %>)におきまして、電気のご契約者さまのご本人確認を実施させていただきます。\nボタンを押してお手続の開始をお願いいたします。\nなお、ご本人確認におきましてはスマートフォンをご使用いただきますので、現在、パソコン等でこのページをご覧になられておられる場合は、お手元にスマートフォンのご用意をお願いいたします。'
    },
    sign: {
      title: '<%= name %>のお申し込みにおける電力データのご提供に関するご同意',
      thanks: {
        ekyc: 'ご本人確認のお手続きありがとうございました。',
        user: 'お申込みいただきました <%= place %>・<%= placeNumber %> の入居者見守りサービス（<%= service %>）におきまして、電気のご契約者さまの電力データのご提供へのご同意手続を実施させていただきます。\nお手続のためのメールをお送りいたしましたので、メールをご確認の上、お手続きの開始をお願いいたします。',
        contractor:
          '<%= name %>さまにてお申込みいただきました <%= place %>・<%= placeNumber %> の入居者見守りサービス（<%= service %>）におきまして、電気のご契約者さまの電力データのご提供へのご同意手続を実施させていただきます。\nお手続のためのメールをお送りいたしましたので、メールをご確認の上、お手続きの開始をお願いいたします。'
      },
      withoutUser: {
        title:
          '入居者見守りサービスのお申し込みにおける電力データのご提供に関するご同意',
        thanks:
          'お申込みいただきました入居者見守りサービスにおきまして、電気のご契約者さまの電力データのご提供へのご同意手続を実施させていただきます。\nお手続のためのメールをお送りいたしましたので、メールをご確認の上、お手続きの開始をお願いいたします。'
      }
    }
  },
  'Illegal postal code': '郵便番号は7桁の数字を入力してください。',
  required: '入力してください',
  'too small': '文字数が不足しています',
  'too large': '文字数が超過しています',
  'Expected string, received null': '入力してください',
  'not postalCode': '郵便番号はハイフンを含まない7つの数字で入力してください',
  'length is': '文字入力してください',
  'must kana': '全角カタカナで入力してください',
  'must number': 'ハイフンなしの数字で入力してください',
  'must mobile': '携帯電話番号を入力してください'
}
